import savingManager from './saving-manager';

export default {
  savingManager,
};
